import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

import { EMPTY, catchError, switchMap } from 'rxjs'

import { FlxButtonComponent, FlxIconModule } from '@flowx/angular-ui-toolkit'
import { FlxSpinnerModule } from '@flowx/designer/shared/components/spinner'
import { CopyResourceSseMessageType } from '@flowx/designer/shared/model/copy-resource.model'

import { CopyResourceService } from '../../services/copy-resource.service'

@Component({
  selector: 'flx-copy-resource-send-data-review-errors',
  templateUrl: 'copy-resource-send-data-review-errors.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlxSpinnerModule, FlxIconModule, FlxButtonComponent],
})
export class CopyResourceSendDataReviewErrorsComponent {
  #copyResourceService = inject(CopyResourceService)
  #destroyRef = inject(DestroyRef)

  successFn = input<() => void>()
  // eslint-disable-next-line @angular-eslint/no-output-native
  close = output()

  loading = this.#copyResourceService.loading
  error = false

  constructor() {
    this.copyResource()
  }

  copyResource(): void {
    this.#copyResourceService.loading.set(true)

    this.#copyResourceService
      .copyResource()
      .pipe(
        switchMap(({ copyId }) => this.#copyResourceService.sseConnection(copyId)),
        catchError(() => {
          this.#copyResourceService.loading.set(false)
          this.error = true
          return EMPTY
        }),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe((sseMessageType) => {
        switch (sseMessageType) {
          case CopyResourceSseMessageType.SUCCESS: {
            if (typeof this.successFn() === 'function') {
              this.successFn()()
            }

            this.closeModal()
            break
          }

          case CopyResourceSseMessageType.ERROR:
            this.error = true
        }
      })
  }

  closeModal(): void {
    this.close.emit()
  }
}
